import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { OnlineCourses } from "@/components/OnlineCourses";
import { RelatedLinks } from "@/components/RelatedLinks";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";

export default function OnlinePage() {
  usePageMeta(
    "Online Courses & On-Demand Training",
    "USDD+ on-demand courses — foundations, freestyle development, performance training, coaching education, cultural dance education and creative development pathways."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="05 · Online Courses & On-Demand Training"
          title="On-demand."
          highlight="On your time."
          description="Cinematic, professionally produced courses you can stream anywhere — foundations, freestyle development, performance training, coaching education, cultural dance education and creative development pathways. Built by working artists, paced for real life."
          ctaPrimary={{ label: "Join the Waitlist", to: "/contact?focus=online&intent=waitlist" }}
          ctaSecondary={{ label: "Start Learning", to: "/contact?focus=online&intent=enquiry" }}
          bg={SITE.classImg2}
        />
        <div data-focus="online" data-testid="online-focus-target">
          <OnlineCourses />
        </div>
        <RelatedLinks
          title="Related"
          items={[
            { tag: "Training", label: "In-person Weekly Training", desc: "London & Kent studios", to: "/training" },
            { tag: "Workshops", label: "Monthly Workshops", desc: "Cultural & social sessions", to: "/workshops" },
            { tag: "Coaching", label: "Teacher Pathway", desc: "Become a USDD instructor", to: "/contact" },
          ]}
        />
      </main>
      <Footer />
    </>
  );
}
